/*
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-04-25 14:08:57
 * @FilePath: /insuranceagent-ui/src/api/insurance/contractManage.js
 * @Description: 合同管理
 */
//模板下载接口
import request from '@/router/axios'

export function getContractList(params) {
	return request({
		url: `/dist/sign/page`,
		method: 'get',
		params,
	})
}

//获取我的合同列表
export function getMyContractList(params) {
	return request({
		url: `/dist/sign/listMy`,
		method: 'get',
		params,
	})
}

//删除
export function clearContract(id) {
	return request({
		url: `/dist/sign/${id}`,
		method: 'delete',
	})
}

// 批量上传执业资格证
export function batchUploadBusinessLicense(ids) {
	return request({
		url: `/dist/sign/batchUploadBusinessLicense`,
		method: 'get',
		params: {ids},
	})
}

// 重置签名
export function resetSign(data) {
	return request({
		url: `/dist/sign/resetSign`,
		method: 'put',
		data,
	})
}
